/**
 * Shared filter/search behaviour used by archive-style blocks.
 *
 * @param {Object} options
 * @param {Element|string} options.root Root element or its CSS selector.
 * @param {string} options.counterInputsSelector Checkbox selector used by the counter.
 */
export function initArchiveFilterSearch({ root, counterInputsSelector }) {
    const container = typeof root === 'string'
        ? document.querySelector(root)
        : root;

    if (!container) return;

    // region Elements
    const filterBox = container.querySelector('.filter-box');
    const filterSection = container.querySelector('.filter-section');
    const searchBox = container.querySelector('.search-box');
    const searchSection = container.querySelector('.search-section');
    const searchInput = container.querySelector('.search-section input[type="search"]');
    const clearBtn = container.querySelector('.search-section .clear');
    // endregion

    // Check if search input has value on load
    if (searchInput && searchInput.value.trim() !== '') {
        if (searchSection) {
            searchSection.style.display = 'flex';
            searchSection.classList.add('search-opened');
        }

        if (searchBox) {
            searchBox.classList.add('active');
        }

        if (clearBtn) {
            clearBtn.style.opacity = '0.6';
            clearBtn.style.pointerEvents = 'auto';
        }
    }

    // region Toggle Filter
    if (filterBox && filterSection) {
        filterBox.addEventListener('click', () => {
            const isOpening = !filterSection.classList.contains('filter-opened');
            filterSection.style.display = 'block';

            // Close search first
            if (searchSection) {
                searchSection.style.display = 'none';
                searchSection.classList.remove('search-opened');
                searchBox?.classList.remove('active');
            }

            filterSection.classList.toggle('filter-opened', isOpening);
            filterBox.classList.toggle('active', isOpening);
        });
    }
    // endregion

    // region Toggle Search
    if (searchBox && searchSection) {
        searchBox.addEventListener('click', () => {
            const isOpening = !searchSection.classList.contains('search-opened');
            searchSection.style.display = 'flex';

            // Close filter first
            if (filterSection) {
                filterSection.style.display = 'none';
                filterSection.classList.remove('filter-opened');
                filterBox?.classList.remove('active');
            }

            searchSection.classList.toggle('search-opened', isOpening);
            searchBox.classList.toggle('active', isOpening);
        });
    }
    // endregion

    // region Clear Button
    if (searchInput && clearBtn) {
        searchInput.addEventListener('input', () => {
            if (searchInput.value.trim() !== '') {
                clearBtn.style.opacity = '0.6';
                clearBtn.style.pointerEvents = 'auto';
            } else {
                clearBtn.style.opacity = '0';
                clearBtn.style.pointerEvents = 'none';
            }
        });

        clearBtn.addEventListener('click', () => {
            searchInput.value = '';
            searchInput.focus();
            clearBtn.style.opacity = '0';
            clearBtn.style.pointerEvents = 'none';

            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('q') && urlParams.get('q').trim() !== '') {
                const searchForm = searchInput.closest('form');
                if (searchForm) {
                    searchForm.submit();
                }
            }
        });
    }
    // endregion

    // region Update Counter
    const form = container.querySelector('.filters.filter-wrapper');
    if (!form || !counterInputsSelector) return;

    const counterEl = form.querySelector('.submit-button span');
    if (!counterEl) return;

    const inputs = form.querySelectorAll(counterInputsSelector);

    const updateCount = () => {
        const count = Array.from(inputs).filter((input) => input.checked).length;
        counterEl.textContent = `(${count})`;
    };

    form.addEventListener('change', (event) => {
        if (event.target.matches('input[type="checkbox"]')) {
            updateCount();
        }
    });

    updateCount();
    // endregion
}
